<template>
  <el-container>
   
    <el-main style="margin:0px;padding:0px;padding-right:20px;">
      <el-container style="margin:0px;padding:0px;overflow:hidden;">
        <el-header style="margin:0px;padding:0px;padding-bottom:5px;height:35px;">
          <el-row type="flex" justify="end">
            <el-col :span="12">
              <el-link  style="font-size:16px;color:#409EFF;" :underline="false" @click="reloadSubject">
                我的患者
                <i class="el-icon-refresh el-icon--right" style="font-size:20px;"></i>
              </el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link  @click="$router.push({path:'/home/subjectform'})" style="font-size:16px;" :underline="false" >表单</el-link>
              <!-- <el-divider direction="vertical"></el-divider>
              <el-link  @click="$router.push({path:'/home/patient'})" style="font-size:16px;" :underline="false" >关注我的患者</el-link> -->
            </el-col>
            <el-col :span="12" style="text-align:right;padding-right:15px;">
           
              <el-button type="primary" size="mini" @click="createsubjectbyscan">扫描二维码</el-button>
              <el-button type="primary" size="mini" style="margin-left:5px;" @click="createSubject()">直接新建</el-button>
              &nbsp;

               <el-popover
                placement="bottom"
                title=""
                width="400"
                trigger="click"
                style="cursor:pointer;"
                >
                <el-input
                  ref="searchinput"
                  placeholder="输入患者姓名、编号、标签进行搜索"
                  prefix-icon="el-icon-search"
                  v-model="searchvalue"
                  clearable
                  >
                </el-input>
                <br><br>
                <div>
                  <span >星标</span><br>
                </div>
                <div style="margin-top:10px;">
                   <span class="fa-stack fa-2x" @click="filterstarflag(5)" >
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(5)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_5" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(4)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(4)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_4" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(3)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(3)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_3" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(2)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(2)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_2" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(1)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(1)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_1" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(0)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(0)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_0" ></i>
                  </span>

                </div>               
                <el-divider content-position="left"></el-divider>
                 <div>标签</div>  
                  <el-tag
                    :key="index"
                    v-for="(tag,index) in tags"
                    :type="(filter_tag !='' && (filter_tag).indexOf(tag.tagname)!= -1)?'':'info'"
                    :disable-transitions="false"
                    @click="filterTag(tag)"
                    style="cursor:pointer;"
                    effect="plain"
                  >
                    {{tag.tagname}} {{tag.num>0?'('+tag.num+')':''}}
                  </el-tag>
                  <el-link v-if="this.tagminnum==1" style="color:gray;font-size:12px;" :underline="false" @click="showFilterTag(0)"><i>显示未分配标签</i></el-link>
                  <el-link v-if="this.tagminnum!=1" style="color:gray;font-size:12px;" :underline="false" @click="showFilterTag(1)"><i>隐藏未分配标签</i></el-link>
                  
                  <br>
                  <div style="float:right">
                    <el-button size="mini" type="primary" @click="resetFilter">重置</el-button>
                  </div>

                <el-link slot="reference" :underline="false">
                  {{(this.filter_tag != '' || this.filter_starflag != '' || this.searchvalue != '') ?'已筛选':'筛选'}}
                  <i class="fa fa-filter" style="font-size:20px;"></i>
                </el-link>
           


              </el-popover>

              
            </el-col>
          </el-row>
          
        </el-header>

        
        <el-main style="margin:0px;padding:0px;">
          <el-table 
          v-loading="loading" 
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background=""
          :empty-text="emptytext"
          :data="computedTableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" 
          :show-header="false" 
            @row-click="table_click" highlight-current-row>
            <el-table-column label="单列" >
              <template slot-scope="scope">
                
                <div >
                      
                  <el-row type="flex" align="middle" style="width:100%;">
                    <el-col :span="1">
                      <el-avatar shape="square" :src="scope.row.headimgurl"  :size="40">
                        <font size="3">{{scope.row.subjectname.substring(scope.row.subjectname.length-2,4)}}</font>
                      </el-avatar>
                      
                    </el-col>
                    <el-col  style="padding-left:8px;" align="left">
                      <el-row >
                        <el-col style="font-size:16px;">
                          <el-row type="flex" justify="end">
                            <el-col :span="10">
                              

                              <!-- {{scope.row.subjectnumber}}  -->
                              {{scope.row.subjectname}}
                              <span style="font-size:14px;color:#666;">
                                {{scope.row.comments | filterComments}}
                              </span>
                              

                            </el-col>
                            <el-col :span="8" style="font-size:14px;color:#666;" align="left">
                              {{scope.row.initials}} 
                              <span v-if="scope.row.sex == 'M'">
                                男
                              </span>
                              <span v-else-if="scope.row.sex == 'F'">
                                女
                              </span>
                              <span v-if="scope.row.dob||'' != ''"> 
                                {{scope.row.dob.split(' ')[0]}}
                                ({{global_getage(scope.row.dob)}}岁)
                              </span>
                            </el-col>
                            <el-col :span="6"  align="right">
                              <!-- <i class="fa fa-line-chart" ></i> 今日新增数据：<span style="font-size:20px;"></span>&nbsp; 
                              <i class="fa fa-file-text-o" ></i> 表单总数：<span style="font-size:20px;">2</span>&nbsp;  
                              <i class="fa fa-database" ></i> 总数据数：<span style="font-size:20px;">10</span>&nbsp;    -->
                              <el-link v-if="scope.row.weixinstatus == 'online'"
                                icon="el-icon-chat-dot-round" @click.stop="showWeixinTalk(scope.row)" :underline="false" style="font-size:20px;padding-right:8px;color:#04BE02;"></el-link>

                              <!-- <el-link icon="el-icon-edit" @click.stop="openSubjectEditor(scope.row)" target="_blank" :underline="false" style="font-size:20px;padding-right:8px"></el-link> -->

                              
                              <el-link icon="el-icon-notebook-2" @click.stop="ToFormInputUrl(scope.row)" 
                                :underline="false" style="font-size:20px;padding-right:8px">
                              </el-link>
                          
                              
                              
                              <el-dropdown @command="flagStar" trigger="click">
                                <span class="el-dropdown-link" style="vertical-align:middle;">
                                  
                                  <i v-if="scope.row.starflag||'' != '' " :class="'fa fa-star starflag_' + scope.row.starflag" style="font-size:20px;padding-right:8px;" :underline="false"></i>
                                  <i v-else class='fa fa-star-o starflag' style="font-size:20px;padding-right:8px"  :underline="false"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown" >
                                  <el-dropdown-item :command="composeValue('5',scope.row.subjectid)"> 
                                    <i class="fa fa-star starflag_5" style="font-size:20px;"></i>             
                                  </el-dropdown-item>
                                  <el-dropdown-item :command="composeValue('4',scope.row.subjectid)"> 
                                    <i class="fa fa-star starflag_4" style="font-size:20px;"></i>                 
                                  </el-dropdown-item>
                                  <el-dropdown-item :command="composeValue('3',scope.row.subjectid)"> 
                                    <i class="fa fa-star starflag_3" style="font-size:20px;"></i>      
                                  </el-dropdown-item>
                                  <el-dropdown-item :command="composeValue('2',scope.row.subjectid)"> 
                                    <i class="fa fa-star starflag_2" style="font-size:20px;"></i>
                                  </el-dropdown-item>
                                  <el-dropdown-item :command="composeValue('1',scope.row.subjectid)"> 
                                    <i class="fa fa-star starflag_1" style="font-size:20px;"></i>
                                  </el-dropdown-item>
                                  <el-dropdown-item :command="composeValue('0',scope.row.subjectid)" divided> 
                                    <i class="fa fa-star-o starflag_0" style="font-size:20px;"></i>
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>
                              
                              <el-popover>

                                <el-button icon="el-icon-edit"  type="mini"  style="font-size:13px;border:0px solid black;" @click.stop="openSubjectEditor(scope.row)">编辑患者</el-button>
                                <!-- <br> -->
                                <!-- <el-button icon="el-icon-delete"  type="mini"  style="font-size:13px;border:0px solid black;" @click="delProject(scope.row.projectid)">删除研究</el-button> -->
                              
                              
                                <!-- <el-button slot="reference"  type="mini" style="font-size:18px;border:0px solid black">...</el-button> -->
                              
                                 <el-link slot="reference"  type="mini" style="font-size:18px;border:0px solid black" :underline="false">...</el-link> 
                              </el-popover>
                            </el-col>
                          </el-row>
                          
                          
                          
                          
                          <!-- <span v-else style="height:20px;">&nbsp;</span> -->
                        </el-col>
                        <el-col>

                          <el-row type="flex" align="middle" style="padding-top:5px;">
                            <el-col :span="16">
                              <!-- <i class="fa fa-line-chart" ></i> 今日新增数据：<span style="font-size:20px;"></span>&nbsp; 
                              <i class="fa fa-file-text-o" ></i> 表单总数：<span style="font-size:20px;">2</span>&nbsp;  
                              <i class="fa fa-database" ></i> 总数据数：<span style="font-size:20px;">10</span>&nbsp;    -->
                              <span v-if="scope.row.category||'' != ''">
                            
                                <el-tag size="mini"  v-for="(item,index) in scope.row.category.split(',')" :key="index">{{item}}</el-tag>
                              </span>
                              
                            </el-col>
                            <el-col :span="8" style="text-align:right;">
                              
                                  
                              <el-link @click.stop="ToFormInputUrl(scope.row)" 
                                :underline="false">
                                <span style="color:#909399">表单/数据: {{scope.row.formcount}}/{{scope.row.answercount}}</span>
                              </el-link>
                                  
                              
                              
                            </el-col>
                          </el-row> 

                        </el-col>
                      </el-row>

                    </el-col>
                  </el-row>

<!-- <el-table :data="subjectFormData" :show-header="false"  max-height="370">
                  <el-table-column prop="formname" label="表单" width="120">
                    <template slot-scope="scope">
                      <font size="1">{{scope.row.formname}}</font>
                      <template v-if="scope.row.category||'' != ''">
                        <br>
                        <el-tag size="mini">{{scope.row.category}}</el-tag>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="answercount" label="数量" width="40">
                  </el-table-column>
                  <el-table-column abel="操作" align="center">                  
                    <template slot-scope="scope">
                      <el-link icon="el-icon-edit"  :underline="false" style="font-size:15px; padding-right:10px" @click="ToFormInputUrlByFormID(scope.row)"></el-link>
                    </template>
                  </el-table-column>
                </el-table> -->

                      
                      
                    

                </div>

                


                
              </template>
            </el-table-column>


            <!-- <el-table-column label="头像" align="right">
              <template slot-scope="scope">
                <el-avatar slot="reference" shape="square" :src="scope.row.headimgurl"  :size="40"><font size="5">{{scope.row.subjectname.substring(0,1)}}</font></el-avatar>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="星标" align="right" width="30px;">
              <template slot-scope="scope">
                <el-dropdown @command="flagStar" trigger="click">
                    <span class="el-dropdown-link">
                      <i v-if="scope.row.starflag||'' != '' " :class="'fa fa-star starflag_' + scope.row.starflag" style="font-size:20px;"></i>
                      <i v-else class='fa fa-star-o starflag' style="font-size:20px;"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                      <el-dropdown-item :command="composeValue('5',scope.row.formid)"> 
                        <i class="fa fa-star starflag_5" style="font-size:20px;"></i>             
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('4',scope.row.formid)"> 
                        <i class="fa fa-star starflag_4" style="font-size:20px;"></i>                 
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('3',scope.row.formid)"> 
                        <i class="fa fa-star starflag_3" style="font-size:20px;"></i>      
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('2',scope.row.formid)"> 
                        <i class="fa fa-star starflag_2" style="font-size:20px;"></i>
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('1',scope.row.formid)"> 
                        <i class="fa fa-star starflag_1" style="font-size:20px;"></i>
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('0',scope.row.formid)" divided> 
                        <i class="fa fa-star-o starflag_0" style="font-size:20px;"></i>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="subjectnumber" label="编号">
              <template slot-scope="scope">

                {{scope.row.subjectnumber}} {{scope.row.subjectname}}&nbsp;{{scope.row.initials}} 
                <span v-if="scope.row.sex == 'M'">
                  男
                </span>
                <span v-else-if="scope.row.sex == 'F'">
                  女
                </span>
                <span v-if="scope.row.dob||'' != ''"> 
                  {{scope.row.dob.split(' ')[0]}}
                  ({{global_getage(scope.row.dob)}}岁)
                </span>
                <br>
                <span v-if="scope.row.category||'' != ''">
                <el-tag size="mini"  v-for="(item,index) in scope.row.category.split(',')" :key="index">{{item}}</el-tag>
                </span>
                <span v-else style="height:20px;">&nbsp;</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="comments" label="备注">

            </el-table-column> -->
       
            <!-- <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-link v-if="scope.row.weixinstatus == 'online'"
                icon="el-icon-chat-dot-round" @click.stop="showWeixinTalk(scope.row)" :underline="false" style="font-size:20px;padding-right:8px;color:#04BE02;"></el-link>

                <el-link icon="el-icon-edit" @click.stop="openSubjectEditor(scope.row)" target="_blank" :underline="false" style="font-size:20px;padding-right:8px"></el-link>
                <el-link icon="el-icon-notebook-2" @click.stop="ToFormInputUrl(scope.row)" :underline="false" style="font-size:20px;padding-right:8px"></el-link>
                
          
              </template>
            </el-table-column> -->
          </el-table>
          

        </el-main>
        <el-footer style="margin:0px;padding:0px;height:30px;" v-if="computedTableData.length>20">
          <el-pagination
                background
                
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 30, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="computedTableData.length">
            </el-pagination>
        </el-footer>
      </el-container>

      <el-dialog title="" 
          :visible.sync="addpatientdialog" 
          @close="reloadSubject()"
          @open="loadUserInfo()"
          :showClose="false"
          width="400px"
          center
        >
          <div v-if="(this.user.openid || '')==''" style="text-align:center">
      
            <div style="padding:8px;">
              请先开启患者互动
            </div>
            <img :src="'/console/user/me?id=' + user.userid" style="width:300px;"/>
            <div style="padding:8px;">
              请使用微信扫描二维码后刷新页面
              
            </div>
          </div>
          <div v-else style="text-align:center">
            
            <div style="padding:8px;">
              请用微信扫码加入交流
            </div>
            
            <img :src="'/console/user/qrcode?id=' + user.userid" style="width:300px;"/>
            <div style="padding:8px;">
              {{this.user.username}} 医生
              <br>
              该二维码（{{this.user.weixin_expireddate}}前）有效
              
            </div>
          </div> 

        </el-dialog>

      <el-drawer
            title="聊天框"
            size = "50%"
            :visible.sync="talk.drawer"
            :with-header="false">
            
                  <template>
                    <el-row style="text-align:center;height:30px;line-height:30px;padding-left:8px;">
                      <el-col>{{this.talk.to}}</el-col>
                    </el-row>

                    <div style=" overflow: hidden;">
                      <el-row>
                        <el-col :span="24" :offset="0">
                          <div
                            id="dataShow"
                            onmouseover="this.style.overflow='overlay'"
                            onmouseout="this.style.overflow='hidden'"
                            class="dataShow"
                          >
                            <div
                              v-for="(item,index) in computedTalkList"
                              :key="index"
                              style="background-color: #f5f5f5; padding:8px;"
                            >
                              <el-row style="text-align:center;padding:3px;">
                                <el-col :span="24" :offset="0">
                                  <span style="font-size:8px;color:#fff;background-color:#dadada;">{{item.talktime}}</span><br>
                                </el-col>
                              </el-row>
                              <el-row v-if="item.sendertype =='PI'">
                                <el-col :span="20" :offset="2">
                                  <!-- <span style="float:right;font-size:8px;color:#fff;background-color:#dadada;">{{item.createddate}}</span><br> -->
                                  
                                    <span v-if="item.messagetype == 'image'" class="aa-image">
                                      <el-image
                                      style="width: 150px;"
                                      :src='"http://yys.waystudy.com/console/wx/getmedia?id="+ item.message +"&amp;type=" + item.messagetype' 
                                      fit="fill"
                                      :preview-src-list='["http://yys.waystudy.com/console/wx/getmedia?id="+ item.message +"&amp;type=" + item.messagetype]'
                                      ></el-image>
                                    </span>
                                    <span v-else-if="item.messagetype=='voice'" class="aa">
                                      (暂无法在线播放)<i class="fa fa-wifi fa-rotate-270"></i>
                                    </span>
                                    <span v-else class="aa">
                                      {{ item.message }}
                                    </span>
                                  
                                </el-col>
                                <el-col :span="1" >
                                  <span> 
                                      <!-- <i class="el-icon-user" style="font-size: 30px" ></i> -->
                                      <el-avatar slot="reference" shape="square" :src="item.piheadimgurl" :size="40"></el-avatar>
                                  </span>
                                </el-col>
                              </el-row>
                            
                              <el-row v-if="item.sendertype =='SUB'">
                                <el-col :span="1">
                                  <span>       
                                      <!-- <i class="el-icon-s-custom" style="font-size: 30px" ></i>   -->
                                      <el-avatar slot="reference" shape="square" :src="item.subheadimgurl"  :size="40"></el-avatar>
                                  </span>
                                </el-col>
                                <el-col :span="20">
                                  <!-- <span style="margin-left: 12px;font-size:8px;color:#fff;background-color:#dadada;">{{item.createddate}}</span><br> -->
                                  
                                    <span v-if="item.messagetype == 'image'" class="bb-image">
                                      <el-image
                                      style="width: 150px;"
                                      :src='"http://yys.waystudy.com/console/wx/getmedia?id="+ item.message +"&amp;type=" + item.messagetype' 
                                      fit="fill"
                                      :preview-src-list='["http://yys.waystudy.com/console/wx/getmedia?id="+ item.message +"&amp;type=" + item.messagetype]'
                                      ></el-image>
                                    </span>
                                    <span v-else-if="item.messagetype=='voice'" class="bb">
                                      <i class="fa fa-wifi fa-rotate-90"></i>(暂无法在线播放)
                                    </span>
                                    <span v-else class="bb">
                                      {{ item.message }}
                                    </span>
                                    
                                  
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>


                    <div id="aa">
                      <!-- <el-divider/> -->
                      <el-row>
                        <el-col :span="22" :offset="1">
                          <el-input
                            v-model="talk.message"
                            type="textarea"
                            autofocus
                            clearable
                            maxlength="100"
                            show-word-limit
                            :autosize="{minRows:3,maxRows:6}"
                            resize="none"
                            placeholder="在这里输入..."
                            @keyup.enter.native="sendMessage"
                          />
                        </el-col>
                      </el-row>
                      <el-row style="margin: 4px 20px">
                        <el-button
                          style="float:right;"
                          type="primary"
                          @click="sendMessage"
                        >
                          发送
                        </el-button>
                      </el-row>
                    </div>
                  </template>


          </el-drawer>
    </el-main>
    <el-aside width="250px" style="border-right: 0px solid #e7e9eb;
      position: relative;
      outline: none;
      color: #767c85;margin-top:20px;margin-bottom:0px;">
      <el-card class="box-card" style="margin-bottom:0px;">
     
        共计 {{computedTableData.length}} 个患者
        <br><br>
        <div ref="chartSex" style="height:180px;"></div>
        <div ref="chartAge" style="height:250px;"></div>
        <div ref="chartTag" style="height:180px;"></div>
      </el-card>
      <!-- <template v-if="this.subjectInfo.subjectname||'' !=''">
            <el-card class="box-card" style="margin-bottom:8px;">
              <div style="padding-bottom:5px;">
                {{this.subjectInfo.subjectname}} {{this.subjectInfo.initials}} 
                <span v-if="this.subjectInfo.sex == 'M'">
                  男
                </span>
                <span v-else-if="this.subjectInfo.sex == 'F'">
                  女
                </span>
                <br>
                <span v-if="this.subjectInfo.dob||'' != ''"> 
                  {{this.subjectInfo.dob.split(' ')[0]}}
                  ({{this.global_getage(this.subjectInfo.dob)}}岁)
                </span>
               
              </div>
   

              <el-table :data="recordhistory" :show-header="false"   style="font-size:4px;width:100%;">
    
                <el-table-column prop="content" label="动作">
                  <template slot-scope="scope">
                    {{scope.row.formname}}
                    <br>
                    {{scope.row.modifieddate}}
                  </template>
                </el-table-column>
               
              </el-table>
  
            </el-card>
      </template>
            <template v-if="this.subjectFormData.length >0">

              <el-card class="box-card">
                <el-row type="flex" style="padding-bottom:5px;">
                  <el-col :span="14" >表单/录入: {{this.subjectFormData.length}}/{{this.totalsubjectFormAnswerCount}}
                   
                  </el-col>
                  <el-col :span="10" style="text-align:right"></el-col>
                </el-row>
                <el-table :data="subjectFormData" :show-header="false"  max-height="370">
                  <el-table-column prop="formname" label="表单" width="120">
                    <template slot-scope="scope">
                      <font size="1">{{scope.row.formname}}</font>
                      <template v-if="scope.row.category||'' != ''">
                        <br>
                        <el-tag size="mini">{{scope.row.category}}</el-tag>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="answercount" label="数量" width="40">
                  </el-table-column>
                  <el-table-column abel="操作" align="center">                  
                    <template slot-scope="scope">
                      <el-link icon="el-icon-edit"  :underline="false" style="font-size:15px; padding-right:10px" @click="ToFormInputUrlByFormID(scope.row)"></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </template> -->
        </el-aside>
  </el-container>
</template>




<script>
export default {
    data() {
      return {
        subjectid:0,
        tableData: [],
        subjectInfo:[],
        recordhistory:[],
        subjectFormData:[],
        loading:true,
        emptytext:" ",
        totalsubjectFormAnswerCount:0,
        filter_starflag:[],
        tags:'',
        filter_tag:[],
        tagminnum:1,
        addpatientdialog:false,
        searchvalue:'',
        user:{},
        

        //聊天框
        talk:{
          drawer:false,
          datalist: [],
          visible: false,
          to:'',
          message:'',
          subjectid:'',
          wxuserid:'',
        },
        // 当前页
        currentPage: 1,
        // 每页多少条
        pageSize: 20
      }
    },
    computed:{
      computedTableData(){
        return this.tableData.filter(data => 
                    //(this.filter_starflag ==0 || data.starflag == this.filter_starflag)
                    (
                        this.filter_starflag =='' || 
                        this.isContained((data.starflag||'0').split(','),this.filter_starflag)
                        // data.category.toLowerCase().indexOf(this.filter_tag.toLowerCase()) != -1 
                    )
                    &&
                    (
                        this.filter_tag =='' || 
                        this.isContained((data.category||'').split(','),this.filter_tag)
                        
                        // data.category.toLowerCase().indexOf(this.filter_tag.toLowerCase()) != -1 
                    )
                    &&
                    (
                        this.searchvalue =='' || 
                        data.subjectname.toLowerCase().indexOf(this.searchvalue.toLowerCase()) != -1 ||
                        (data.category || '').toLowerCase().indexOf(this.searchvalue.toLowerCase()) != -1    ||
                        (data.subjectnumber ||'').toLowerCase().indexOf(this.searchvalue.toLowerCase()) != -1 
                        
                    )
                    );
      },
      computedTalkList(){
        let arryData =[];
        let lasttime = "";
        this.talk.datalist.forEach(element => {
          if(lasttime == "")
          { 
            element.talktime = this.$moment(element.createddate).format("YYYY年MM月DD日 HH:mm:ss");
          }
          else if(this.$moment(element.createddate).diff(this.$moment(lasttime), 'minutes') !=0)
          {   
            element.talktime = this.$moment(element.createddate).format("YYYY年MM月DD日 HH:mm:ss");
          }

          lasttime = element.createddate;

          arryData.push(element);
        });

        return arryData;
      }
      
    },
    watch:{
      computedTableData(val){
        this.showChart();
      },
    },
    mounted:function(){
      this.loadList();
      this.getTagList();
      this.loadUserInfo();
      
    },
    methods:{
      loadUserInfo(){
        this.$http.get('user/profile').then((res) => { 
          this.user = res.data.info;
        });
      },
      reloadSubject(){
        this.filter_starflag = [];
        this.filter_tag =[];
        this.loadList();
        this.getTagList();
      },
      table_click(row,event,column){
        this.subjectid = row.subjectid;
        // this.getsubjectinfo(row.subjectid);
        // this.getSubjectFormRecordStaticstics(row.subjectid);
        // this.getSubjectFormRecordHistory(row.subjectid);
      },
      getsubjectinfo(subjectid){
        this.$http.get('subject/info',
        {
          params:{subjectid:subjectid}
        })
        .then((res) => { 
          this.subjectInfo = res.data.info;
        });
      },
      getSubjectFormRecordStaticstics(subjectid){
        this.$http.get("subject/SubjectFormRecordStaticstics",
        {
          params:{subjectid:subjectid}
        })
        .then((res) => { 
          this.subjectFormData = res.data.list;
          this.totalsubjectFormAnswerCount =0;
          res.data.list.forEach((item,index)=>{
            this.totalsubjectFormAnswerCount = this.totalsubjectFormAnswerCount + parseInt(item.answercount);
          })
        });
      },
      getSubjectFormRecordHistory(subjectid){
        this.$http.get("subject/SubjectFormRecordHistory",
        {
          params:{subjectid:subjectid}
        })
        .then((res) => { 
          this.recordhistory = res.data.list;
        });
      },
      ToFormInputUrl(row){
        this.$router.push({ name: 'forminput', query: {id:row.subjectid }})
      },
      ToFormInputUrlByFormID(row){
        
        this.$router.push({ name: 'forminput', query: {id:this.subjectid,formid:row.formid}})
      },
      loadList(){
        this.emptytext =" ";
        this.loading = true;

        this.$http.get('subject/list').then((res) => { 
            this.tableData = res.data.list;
            this.loading = false;
            this.emptytext ="";
              });
      },
      //创建受试者
      createSubject(){
        this.$router.push({name:'subject-new',query:{}});
      },
      createsubjectbyscan(){
        this.addpatientdialog = true;
      },
      openSubjectEditor(row){
        this.$router.push({name:'subject-new',query:{id:row.subjectid}});
      },
      flagStar(command){
        this.$http.post('subject/flagstar', {'subjectid':command.subjectid,'starflag':command.starflag}).then((res) => { 
            this.loadList();
              }); 
      },
      composeValue(color,subjectid){
        return{starflag:color,subjectid:subjectid};
      },
      filterstarflag(value){
       
        
        if(this.filter_starflag.indexOf(value) >-1)
        {
          //已存在，去掉
          this.filter_starflag.splice(this.filter_starflag.indexOf(value), 1);
        }
        else
        {
          //目前星标只允许选一个，做的是并且关系，留个坑，为或关系做准备
          this.filter_starflag = [];
          this.filter_starflag.push(value);
        }
      

        //清空右边的栏目信息
        this.subjectInfo = {};
        this.subjectFormData ={};
      },

      //聊天框--start
      showWeixinTalk(row){
        this.talk.to = row.subjectnumber + ' ' + row.subjectname;
        this.talk.wxuserid = row.weixinuserid;
        this.talk.subjectid = row.subjectid;
        this.talk.drawer = true;

        this.getWeixinTalk();
      },
      getWeixinTalk(){
        this.$http.get('weixinuser/getweixinusertalk',
          {
            params:{
                      subjectid:this.talk.subjectid,
                   }
          }).then(res=>{
          if(!res) return;
          
            this.talk.datalist = res.data.list;
            this.scrollToBottom();
        });
      },
      clearBr(key) {
        key = key.replace(/<\/?.+?>/g, '')
        key = key.replace(/[\r\n]/g, '')
        return key
      },
      sendMessage(){
        this.talk.message = this.clearBr(this.talk.message)
        if (this.talk.message === '' || this.talk.message === undefined || this.talk.message === null) {
          this.$message.error('不能发送空白消息')
        }
        else{

          this.$http.post('weixinuser/sendweixinmessage',
            { 
              'message':this.talk.message,
              //'wxuserid':this.talk.wxuserid,
              'subjectid':this.talk.subjectid,
            })
          .then((res)=>{
            if(!res) return;
            
            this.talk.message = '';
            this.getWeixinTalk();

          });
        }

      },
      // 滚动到底部
      scrollToBottom() {
        this.$nextTick(() => {
          const div = document.getElementById('dataShow')
          div.scrollTop = div.scrollHeight
        })
      },
      //聊天框--end

      //搜索条件，标签
      getTagList(){
        this.$http.get('tag/list',{params:{tagtype:'SUBJECT',minnum:this.tagminnum}}).then((res)=>{
          if(!res) return;
          this.tags = res.data.list;
        })
      },
      showFilterTag(tagnum){
        this.tagminnum = tagnum;
        this.getTagList();
      },
      filterTag(tag){
        let tagname = tag.tagname;
        if(tagname){
          if(this.filter_tag.indexOf(tagname) >-1)
          {
            //已存在，去掉
            this.filter_tag.splice(this.filter_tag.indexOf(tagname), 1);
          }
          else
          {
            this.filter_tag.push(tagname);
          }
        }

        //清空右边的栏目信息
        this.subjectInfo = {};
        this.subjectFormData ={};

      },

      resetFilter(){
        this.filter_tag =[];
        this.filter_starflag =[];
        this.searchvalue = '';

        //清空右边的栏目信息
        this.subjectInfo = {};
        this.subjectFormData ={};
      },

      isContained(aa,bb){
        if(!(aa instanceof Array) || !(bb instanceof Array) ) {
          return false;
        }
      
        for (var i = 0; i < bb.length; i++) {
          var flag = false;
          for(var j = 0; j < aa.length; j++){
            if(aa[j] == bb[i]){
              flag = true;
              break;
            }
          }
          if(flag == false){
            return flag;
          }
        }
        
        return true;
      },


      showChart(){
        this.getChartSex();
        this.getChartAge();
        this.getChartTag();
      },

      getChartSex() {
        let chartSex = this.$echarts.init(this.$refs.chartSex);

        let malecount = 0;
        let femalecount= 0;
        let unknowncount =0;
        this.computedTableData.forEach(item => {
          if(item.sex == "M"){
            malecount ++;
          }else if(item.sex == "F"){
            femalecount ++;
          }else{
            unknowncount ++;
          }
        
        });

        let chartData = [
          {value:malecount,name:'男'},
          {value:femalecount,name:'女'},
          {value:unknowncount,name:'未知'},
        ];

        let option = {
            title: {
                text: '性别',
            
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c} <br>{d}%',
                confine:'true',  //限制在显示框内
            },
            // legend: {
            //     orient: 'vertical',
            //     left: 'left',
            //     data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
            // },
            series: [
                {
                    name: '性别',
                    type: 'pie',
                    radius: ['30%','90%'],
                    center: ['50%', '50%'],
                    data: chartData,
                    label:{
                      normal:{
                        position:'inner',
                        formatter:'{b}:{c}\n{d}%',
                        textStyle:{
                          fontWeight:'normal',
                          fontSize:10,
                        }
                      },
                    },
                    labelLine:{
                      normal:{
                        show:true,
                      }
                    }
                }
            ]
        };

        chartSex.setOption(option);
      },

      getChartAge() {
        let chartAge = this.$echarts.init(this.$refs.chartAge);

        let chartDataY = [
          '1-19','20-29','30-39','40-49','50-59','60-69','70-79','80-89','90以上'
        ];
        let chartData=[0,0,0,0,0,0,0,0,0];
        this.computedTableData.forEach(item => {
          if(item.dob){
            let age = this.global_getage(item.dob);
            if(age <= 19){
              chartData[0]++;
            }else if(age <=29){
              chartData[1]++;
            }else if(age <=39){
              chartData[2]++;
            }else if(age <=49){
              chartData[3]++;
            }else if(age <=59){
              chartData[4]++;
            }else if(age <=69){
              chartData[5]++;
            }else if(age <=79){
              chartData[6]++;
            }else if(age <=89){
              chartData[7]++;
            }else{
              chartData[8]++;
            }
          }

          // if(item.category){
          //   item.category.split(",").forEach(tag => {
          //      let isExist =false;
          //      test.forEach(element => {
          //        if(element.tag==tag) 
          //        {
          //           isExist=true;
          //           element.value++;
          //        }
          //      });

          //      if(!isExist){
          //       test.push({tag:tag,value:1});
          //      }
               
          //   });
          // }
          
        });

        

        let option = {
          title:{
            text: '年龄',
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'shadow'
              }
          },
          grid: {
              left: '2%',
              right: '3%',
              bottom: '3%',
              containLabel: true
          },
          xAxis: {
              type: 'category',
              data: chartDataY,
              boundaryGap: [0, 0.01],
              axisLabel:{
                show:true,
                interval:0,
                rotate:40,
                // formatter:function(value,index){
                //   if(index %2 !=0){
                //     return '\n\n' + value;
                //   }else{
                //     return value;
                //   }
                //   //return value.split("").join("\n");
                // }
              },
              axisLine:{
                show:true,
              },
              splitLine:{
                show:false,
              }
          },
          yAxis: {
              type: 'value',
              
              axisLabel:{
                show:true,
              },
              axisLine:{
                show:false,
              },
              splitLine:{
                show:true,
                lineStyle:{
                  //color:'blue',
                }

              }
          },
          series: [
              {
                  name: '',
                  type: 'bar',
                  data: chartData,
                  label:{
                    show:true,
                    position:'top',
                    rotate:0,
                    formatter:'{c}'

                  }
              }
          ]
        };

        chartAge.setOption(option);
      },

      getChartTag() {
      
        let chartTag = this.$echarts.init(this.$refs.chartTag);

        let chartData =[];

        this.computedTableData.forEach(item => {
          
          if(item.category){
            item.category.split(",").forEach(tag => {
               let isExist =false;
               chartData.forEach(element => {
                 if(element.name==tag) 
                 {
                    isExist=true;
                    element.value++;
                 }
               });

               if(!isExist){
                chartData.push({name:tag,value:1});
               }
               
            });
          }
          
        });

        let option = {
            title: {
                text: '标签',
            
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c} <br>{d}%',
                confine:'true',
            },
            series: [
                {
                    name: '标签',
                    type: 'pie',
                    radius: ['30%','90%'],
                    center: ['50%', '50%'],
                    data: chartData,
                    label:{
                      normal:{
                        position:'inner',
                        formatter:'{b}:{c}\n{d}%',
                        textStyle:{
                          fontWeight:'normal',
                          fontSize:10,
                        }
                      },
                    },
                    labelLine:{
                      normal:{
                        show:true,
                      }
                    }
                }
            ]
        };

        chartTag.setOption(option);
      },



      // 每页多少条
      handleSizeChange(val) {
          this.pageSize = val;
      },
      // 当前页
      handleCurrentChange(val) {
          this.currentPage = val;
      },
      

    },
    filters: {
      filterComments(value) {
        if (!value) return "";
        if (value.length > 18) {
          return value.slice(0, 18) + "...";
        }
        return value;
      }
    },
  };
</script>

<style scoped>
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }

  .starflag{
    color:#65676A;
  }
  .starflag_1{
    color:rgb(212, 70, 66);
    margin-right: 10px;
  }
  .starflag_2{
    color:rgb(232, 140, 64);
    margin-right: 10px;
  }
  .starflag_3{
    color:rgb(170, 64, 156);
    margin-right: 10px;
  }
  .starflag_4{
    color:rgb(98, 165, 93);
    margin-right: 10px;
  }
  .starflag_5{
    color:rgb(88, 158, 248);
    margin-right: 10px;
  }

  

  .el-tag + .el-tag{
    margin:10px;
  }
</style>